var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-close-btn-point" }, [
      _c(
        "div",
        {
          staticClass: "modal-close-btn-container",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("SVGModalClose")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-title-big" }, [
      _vm._v("\n        Поделиться\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-borderline no-margin-top" }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-data-container" }, [
      _c("div", { staticClass: "ap-modal-element" }, [
        _c("div", { staticClass: "design-name-input-grid" }, [
          _c("div", [
            _c("div", { staticClass: "ap-modal-input-name" }, [
              _vm._v("\n                        Ссылка\n                    ")
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "cd-modal-text-input",
              attrs: { type: "text", readonly: "" },
              domProps: { value: _vm.url }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gl-square-btn btn-red design-name-button",
              attrs: { title: "Скопировать" },
              on: {
                click: function($event) {
                  return _vm.copyUrl()
                }
              }
            },
            [_c("SVGCopy", { staticClass: "svg-14" })],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ap-modal-element copy-tip" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCopied,
                expression: "isCopied"
              }
            ]
          },
          [_vm._v("\n                Ссылка скопирована!\n            ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }